import React from 'react'
import cx from 'classnames'
import { FormattedMessage } from 'react-intl'
import SummaryLoader from 'components/SummaryLoader'
import messages from './messages'
import styles from './SummarySection.scss'

interface SummarySectionProps {
  isLoading?: boolean
  name: string
  showHeader?: boolean
  children?: React.ReactNode
}

const SummarySection: React.FC<SummarySectionProps> = ({ 
  isLoading = false, 
  name, 
  showHeader = true, 
  children 
}) => (
  <section className={cx(styles.section, styles[name])}>
    {isLoading ? (
      <SummaryLoader />
    ) : (
      <>
        {showHeader && (
          <h2 className={styles.header}>
            <FormattedMessage {...messages.headers[name]} />
          </h2>
        )}
        <div className={cx(styles.content, styles[name])}>{children}</div>
      </>
    )}
  </section>
)

export default SummarySection

